import { type InputHTMLAttributes, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Input as InputBase } from '../Input';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  explanation?: string;
  label: string;
  name: string;
}

export function Input(props: Props) {
  const [error, setError] = useState('');
  const { explanation, label, className, ...rest } = props;

  return (
    <label className={twMerge('block', 'group', className)}>
      <div className="grid gap-x-2 items-center grid-cols-[max-content_1fr]">
        <div className="font-bold text-white text-sm">{label}</div>
        {error && (
          <div className="truncate text-right text-rose-500 text-sm hidden group-has-[:user-invalid:not(:placeholder-shown)]:block">
            {error}
          </div>
        )}
      </div>
      {explanation && (
        <div className="text-sm text-neutral-400">{explanation}</div>
      )}
      <InputBase
        wrapperClassName="mt-1"
        onInvalid={(e) => {
          setError(e.currentTarget.validationMessage);
        }}
        {...rest}
      />
    </label>
  );
}
